import React from "react";
import { Col, DatePicker, Form, Input, Row, Select, Spin } from "antd";
import { useQuery } from "react-query";
import { AxiosEmployeeAPI } from "../Api";

const EmployeeTerminationModalForm = ({ form }) => {
  const { TextArea } = Input;

  const { data, isLoading } = useQuery(
    ["terminationTypes"],
    () => AxiosEmployeeAPI.getTerminationTypes({}),
  );

  if (isLoading) {
    return <Spin active />;
  }

  return (
    <Form
      labelCol={{ span: 24 }}
      wrapperCol={{ span: 24 }}
      autoComplete="off"
      layout={"vertical"}
      form={form}
      style={{ width: "100%" }}
    >
      <Row>
        <Col xs={24} sm={24} md={9} lg={9} xl={9}>
          <Form.Item
            label="Data de desligamento"
            name="date"
            rules={[
              {
                required: true,
                message: "Coloque a data de desligamento!",
              },
            ]}
          >
            <DatePicker
              placeholder={"Selecione uma data"}
              format={"DD/MM/YYYY"}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24} md={7} lg={7} xl={7}>
          <Form.Item
            label="Tipo de desligamento"
            name="termination_type"
            rules={[
              {
                required: true,
                message: "Coloque o tipo de desligamento!",
              },
            ]}
          >
            <Select>
              {data?.map((type) => (
                <Select.Option value={type.value}>
                  {type.description}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
      <Form.Item label="Motivo de desligamento" name="reasons">
        <TextArea rows={4} />
      </Form.Item>
    </Form>
  );
};

export default EmployeeTerminationModalForm;
